import { TextField } from '@mui/material';
import styled from 'styled-components';
import { computeSize } from '../../utils/object-utilities';
import { heightToPixel } from '../../utils/consts';
import { Orientation } from './consts';
import Icons from '../Icons';

export const Connector = styled.div.attrs(() => ({
  className: 'dateRangeInputsConnectors' // can be used to hide it
}))`
  margin-left: 8px;
  margin-right: 8px;
  color: var(--input-secondary-text-color);
  font-weight: 600;
`;

export const InputContainer = styled.div.attrs(() => ({
  className: 'dateRangeInputsContainer' // can be used to change orientation to flex column
}))`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ $orientation }) => $orientation === Orientation.VER && 'column'};
  gap: 10px;
  width: 100%;
  align-items: center;
  padding-top: 10px;

  .MuiFormLabel-root,
  .MuiInputBase-input {
    font-family: var(--app-font) Averta, sans-serif;
    font-size: 14px;
  }
  .MuiInputBase-input {
    color: var(--date-input-color, inherit);
    -webkit-text-fill-color: var(--date-input-color, currentColor);
  }
  .MuiFormLabel-root {
    color: var(--date-input-label-color, rgba(0, 0, 0, 0.6));
  }
  .MuiFormLabel-root.Mui-focused {
    color: var(--date-input-label-focused-color, rgba(0, 0, 0, 0.6));
  }
  .MuiInputBase-input::placeholder {
    color: var(--date-input-placeholder-color, currentColor);
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: var(--inputBorderColor);
    border-width: 1px;
  }
  .MuiOutlinedInput-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--inputFocusedColor);
    border-width: 1px;
  }
  .MuiOutlinedInput-root {
    border-radius: var(--input-border-radius);
    background-color: var(--select-bg-color);
    font-size: 14px;
    color: var(--select-text-color);
    height: ${({ $height }) => computeSize($height, heightToPixel, '35px')};
  }
`;

export const DatePickerWrapper = styled.div.attrs(() => ({
  className: 'dsc-datePicker'
}))`
  position: relative;
  width: ${({ $width }) => $width};
  &&& {
    .MuiInputBase-root {
      &.Mui-disabled {
        background-color: var(--inputDisabledBgColor);
      }
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputBorderColor);
      border-width: 1px;
    }
    .MuiOutlinedInput-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputFocusedColor);
      border-width: 1px;
    }
    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: var(--red);
      border-width: 1px;
    }
    .MuiOutlinedInput-root {
      border-radius: var(--input-border-radius);
      background-color: var(--select-bg-color);
      font-size: 14px;
      color: var(--select-text-color);
      height: ${({ $height }) => computeSize($height, heightToPixel, '35px')};
    }
  }
`;

export const TextFieldWrapper = styled(TextField)`
  && {
    flex: ${({ $inputWidth }) => !$inputWidth && 1};
    width: ${({ $inputWidth }) => $inputWidth};
  }
`;

export const DateRangePopperWrapper = styled.div`
  height: 100%;
`;

export const Label = styled.div`
  display: flex;
  gap: 10px;
  font-size: 14px;
  opacity: ${({ disabled }) => disabled && '0.6'};
`;

export const SelectPlaceholder = styled(Label)`
  display: flex;
  color: var(--select-text-color);
  align-items: center;
`;
export const ControlWrapper = styled.div`
  position: relative;
`;

export const LoadingIcon = styled(Icons.InProgress)`
  position: absolute;
  top: -8px;
  right: -8px;
`;
